import axios from 'axios'
import { getSavedState, saveState } from '../store-utils'

export const state = {
  cachedShifts: getSavedState('device.shifts'),
  selectedShift: null,
}

export const getters = {
  cachedShifts(state) {
    return state.cachedShifts
  },
  selectedShift(state) {
    return state.selectedShift
  },
}

export const mutations = {
  SET_CACHE(state, shifts) {
    state.cachedShifts = shifts
    saveState('device.shifts', shifts)
  },
  SET_SELECTED(state, shift) {
    state.selectedShift = shift
  },
}

export const actions = {
  selectShift({ commit, state, rootState }, { shift }) {
    commit('SET_SELECTED', shift)
  },

  fetchShifts({ commit, state, rootState }, { clearCache }) {
    // 1. Check if we've already fetched and cachedGroups the shift groups.
    const matchedShifts = state.cachedShifts
    if (!clearCache && matchedShifts) {
      return Promise.resolve(matchedShifts)
    }

    // 2. Fetch the shifts from the API and cache it in case
    // we need it again in the future.
    return axios
      .get('/api/services/app/DeviceShift/GetAll')
      .then((response) => {
        const shifts = response.data.items
        commit('SET_CACHE', shifts)
        return shifts
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          this.$router.push('Login')
        }
        return null
      })
  },

  updateShift({ commit, dispatch, state, rootState }, { shift }) {
    return axios
      .put('/api/services/app/DeviceShift/Update', shift)
      .then((response) => {
        dispatch('fetchShifts', { clearCache: true }).then((resp) => {
          commit('SET_SELECTED', null)
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  updateShiftPattern({ commit, dispatch, state, rootState }, { shiftPattern }) {
    return axios
      .put('/api/services/app/DeviceShiftPattern/Update', shiftPattern)
      .then((response) => {
        dispatch('fetchShifts', { clearCache: true }).then((resp) => {
          commit('SET_SELECTED', null)
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
